import {
  useMsal,
  useIsAuthenticated,
  AuthenticatedTemplate,
} from "@azure/msal-react";
import { CustomAccountInfo } from "../../../types/customAccountInfo";
import { FC, useEffect, useState } from "react";

interface RoleComponentGuardProps {
  roles: string[];
  children: React.ReactNode;
}

export const RoleComponentGuard: FC<RoleComponentGuardProps> = ({
  roles,
  children,
}) => {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [isAuthorized, setIsAuthorized] = useState<boolean>(false);

  useEffect(() => {
    async function onLoad() {
      const currentAccount = instance.getActiveAccount() as CustomAccountInfo;

      if (currentAccount && currentAccount.idTokenClaims?.["role"]) {
        const userRoles = currentAccount.idTokenClaims["role"];
        const userRolesArray = Array.isArray(userRoles)
          ? userRoles
          : [userRoles]; // Ensure roles are in an array

        // Check for intersection between user's roles and required roles
        const intersection = roles.filter((role) =>
          userRolesArray.includes(role)
        );
        setIsAuthorized(intersection.length > 0);
      } else {
        setIsAuthorized(false);
      }
    }
    onLoad();
  }, [isAuthenticated, roles, instance]);

  return (
    <>
      {isAuthorized ? (
        <AuthenticatedTemplate>{children} </AuthenticatedTemplate>
      ) : null}
    </>
  );
};
